import type { AppProps } from 'next/app';
import { GlobalStyles } from '../theme/globalStyles';
import { ToastifyStyles } from '../styles/toastify';
import { Provider } from 'react-redux';
import { ThemeProvider } from 'styled-components';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { appWithTranslation } from 'next-i18next';
import { initializeStore } from '../store/store';
import { themeConfig } from '../theme/themeConfig';

function MyApp({ Component, pageProps }: AppProps) {

  const theme = themeConfig(pageProps.preloadedState?.ui?.pallette);

  return (
    <Provider store={initializeStore(pageProps.preloadedState)}>
      <ThemeProvider theme={theme}>
        <GlobalStyles />
        <ToastifyStyles />
        <ToastContainer
          position="top-right"
          autoClose={2000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
          limit={2}
          theme='light'
        />
        <Component {...pageProps} />
      </ThemeProvider>
    </Provider>
  );
}

export default appWithTranslation(MyApp);
